<b2b-login-form-generic :css="css" :logo="logo" :backImg="backImg" :next="next" :localproject="localproject" :logomenu="logomenu"></b2b-login-form-generic>